// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "text_normal-yAksa";
var _3 = "text_light-1FRM2";
var _4 = "segment-15SBc text_normal-yAksa";
var _5 = "segment_disabled-2M4bD";
var _6 = "dateWrp-2XX_f";
var _7 = "flightInfo-1JqHA";
var _8 = "airplane-Dyis0";
var _9 = "selectWrp-29-9a";
var _a = "route-2Y5bF";
var _b = "time-32D_V text_light-1FRM2";
var _c = "flight-2j23G text_light-1FRM2";
var _d = "selectLabel-3vEOC text_light-1FRM2";
var _e = "iata-2W4Gu text_light-1FRM2";
var _f = "selectLabel_disabled-1Miq9";
var _10 = "checkbox-3Tlp1";
var _11 = "checkbox_checked-3cZiv";
export { _1 as "__esModule", _2 as "text_normal", _3 as "text_light", _4 as "segment", _5 as "segment_disabled", _6 as "dateWrp", _7 as "flightInfo", _8 as "airplane", _9 as "selectWrp", _a as "route", _b as "time", _c as "flight", _d as "selectLabel", _e as "iata", _f as "selectLabel_disabled", _10 as "checkbox", _11 as "checkbox_checked" }
export default { "__esModule": _1, "text_normal": _2, "text_light": _3, "segment": _4, "segment_disabled": _5, "dateWrp": _6, "flightInfo": _7, "airplane": _8, "selectWrp": _9, "route": _a, "time": _b, "flight": _c, "selectLabel": _d, "iata": _e, "selectLabel_disabled": _f, "checkbox": _10, "checkbox_checked": _11 }
